module.exports = [
    {label: 'Communication', value: 'communication'},
    {label: 'Courses', value: 'courses'},
    {label: 'Crafts', value: 'crafts'},
    {label: 'Entertainment', value: 'entertainment'},
    {label: 'Games', value: 'games'},
    // {label: 'Health', value: 'health'},
    {label: 'Hobbies', value: 'hobbies'},
    // {label: 'Safety', value: 'safety'},
    {label: 'Social', value: 'social'},
    {label: 'Spirituality', value: 'spirituality'},
    {label: 'Technology', value: 'technology'},
    // {label: 'Therapy', value: 'therapy'},
    {label: 'Travel', value: 'travel'},
    {label: 'Volunteer', value: 'volunteer'},
    {label: 'Wellness', value: 'wellness'}
];